<template>
  <v-card>
    <div class="d-flex justify-space-between align-center px-4 py-2">
      <h3 v-text="$t('profile.form.cardHeader')" class="primary--text"></h3>
      <v-btn icon @click="$emit('closeEditProfileInformation')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <v-divider></v-divider>

    <div
      class="d-flex flex-column px-4 pt-4"
      style="max-height:60vh; overflow-y:scroll"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <!-- UsernameInput -->
        <v-text-field
          outlined
          counter="50"
          :rules="this.editingProfileRules.username"
          v-model="editedCreator.user.username"
          color="primary"
          required
          v-bind:label="$t('profile.form.username')"
          :hint="$t('profile.form.username')"
          ref="usernameInput"
          :error-messages="$t(errors.usernameInput)"
          @focus="removeInputErrorMessage('usernameInput')"
          append-icon="fas fa-at"
          disabled
        >
        </v-text-field>
        <!-- emailInput -->
        <v-text-field
          type="mail"
          v-model="editedCreator.user.email"
          :rules="editingProfileRules.email"
          color="primary"
          outlined
          required
          v-bind:label="$t('profile.form.email')"
          :hint="$t('profile.form.email')"
          ref="emailInput"
          :error-messages="$t(errors.emailInput)"
          @focus="removeInputErrorMessage('emailInput')"
          disabled
          append-icon="fas fa-envelope"
          hide-details
        >
        </v-text-field>
        <div class="d-flex justify-center flex-wrap mt-2">
          <v-btn
            small
            text
            color="primary"
            class="text-lowercase font-weight-medium mb-2"
            @click.stop="
              displayHowToEditUsernameOrEmail = !displayHowToEditUsernameOrEmail
            "
          >
            Modifier mon nom d'utilisateur ou email ?
          </v-btn>
          <v-slide-y-transition>
            <v-alert
              v-show="displayHowToEditUsernameOrEmail"
              dense
              text
              color="primary"
              class="text-center"
            >
              Tu peux nous transmettre ta demande par
              <span class="font-weight-bold"
                >email via contact@gemmici.com</span
              >
              ou par
              <span class="font-weight-bold">message privé sur Facebook</span>.
            </v-alert>
          </v-slide-y-transition>
        </div>
        <!-- firstNameInput -->
        <v-text-field
          :rules="this.editingProfileRules.first_name"
          v-model="editedCreator.user.firstName"
          color="primary"
          outlined
          required
          v-bind:label="$t('profile.form.first_name')"
          :hint="$t('profile.form.first_name')"
          append-icon="fas fa-font"
        >
        </v-text-field>
        <!-- DescriptionInput -->
        <v-textarea
          outlined
          color="primary"
          counter="300"
          required="false"
          v-bind:label="$t('profile.form.description')"
          v-model="editedCreator.description"
          :rules="editingProfileRules.description"
        ></v-textarea>
        <div
          v-for="(website, index) in this.editedCreator.websites"
          :key="index"
        >
          <!-- WebsiteNameInput -->

          <v-text-field
            outlined
            counter="100"
            v-model="website.name"
            :rules="editingProfileRules.website_name"
            color="primary"
            required
            v-bind:label="$t('profile.form.websiteName')"
            :hint="$t('profile.form.websiteName')"
          >
            <template v-slot:append>
              <v-icon color="primary">fas fa-font</v-icon>
            </template>
          </v-text-field>

          <!-- WebsiteURL -->
          <v-text-field
            outlined
            v-model="website.url"
            :rules="editingProfileRules.website_url"
            color="primary"
            disabled
            v-bind:label="$t('profile.form.websiteUrl')"
            :hint="$t('profile.form.websiteUrl')"
          >
            <template v-slot:append>
              <v-icon color="primary">fas fa-link</v-icon>
            </template>
          </v-text-field>
        </div>

        <!-- instagramURLInput -->

        <v-text-field
          outlined
          v-model="editedCreator.instagramUrl"
          :rules="editingProfileRules.instagram_url"
          required="false"
          color="primary"
          v-bind:label="$t('profile.form.instagramAccount')"
          :hint="$t('profile.form.instagramAccount')"
          ><template v-slot:append>
            <v-icon color="primary">fab fa-instagram</v-icon>
          </template>
        </v-text-field>

        <!-- twitterURLInput -->

        <v-text-field
          v-model="editedCreator.twitterUrl"
          :rules="editingProfileRules.twitter_url"
          outlined
          color="primary"
          v-bind:label="$t('profile.form.twitterAccount')"
          :hint="$t('profile.form.twitterAccount')"
          ><template v-slot:append>
            <v-icon color="primary">fab fa-twitter</v-icon>
          </template>
        </v-text-field>

        <!-- facebookURLInput -->

        <v-text-field
          v-model="editedCreator.facebookUrl"
          :rules="editingProfileRules.facebook_url"
          outlined
          color="primary"
          v-bind:label="$t('profile.form.facebookAccount')"
          :hint="$t('profile.form.facebookAccount')"
          ><template v-slot:append>
            <v-icon color="primary">fab fa-facebook</v-icon>
          </template>
        </v-text-field>
        <!-- Pinterest Input -->
        <v-text-field
          v-model="editedCreator.pinterestUrl"
          :rules="editingProfileRules.pinterest_url"
          outlined
          clearable
          color="primary"
          v-bind:label="$t('profile.form.pinterestAccount')"
          :hint="$t('profile.form.pinterestAccount')"
          ><template v-slot:append>
            <v-icon color="primary">fab fa-pinterest</v-icon>
          </template>
        </v-text-field>
      </v-form>
    </div>
    <!-- SaveButton -->
    <v-divider></v-divider>
    <div class="pa-4">
      <v-btn
        large
        color="primary"
        block
        @click="editProfile()"
        :disabled="!valid"
      >
        {{ $t("profile.form.saveModification") }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import Creator from "../classes/Creator";
import ErrorInputMixins from "@/services/ErrorInputMixins";
import FormFunctions from "@/services/FormFunctions";
export default {
  name: "AccountEditInformationModal",
  mixins: [ErrorInputMixins],
  data() {
    return {
      date: null,
      editingProfileRules: {
        username: [
          v => !!v || this.$i18n.t("profile.rules.username.required"),
          v => v.length >= 1 || this.$i18n.t("profile.rules.username.min"),
          v => v.length <= 50 || this.$i18n.t("profile.rules.username.max"),
          v =>
            /^\S*$/.test(v) || this.$i18n.t("profile.rules.username.noSpace"),
          v =>
            /^[a-z0-9@+\-._]+$/gi.test(v) ||
            this.$i18n.t("profile.rules.username.specialCaracters")
        ],
        first_name: [
          v => !!v || this.$i18n.t("profile.rules.first_name.required"),
          v => v.length <= 30 || this.$i18n.t("profile.rules.first_name.max"),
          v =>
            /^[\wáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ\s]+$/gi.test(
              v
            ) || this.$i18n.t("profile.rules.first_name.specialCaracters")
        ],
        last_name: [
          v => !!v || this.$i18n.t("profile.rules.last_name.required"),
          v => v.length <= 150 || this.$i18n.t("profile.rules.last_name.max"),
          v =>
            /^[\wáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ\s]+$/gi.test(
              v
            ) || this.$i18n.t("profile.rules.last_name.specialCaracters")
        ],
        email: [
          v => !!v || this.$i18n.t("profile.rules.email.required"),
          v => v.length <= 254 || this.$i18n.t("profile.rules.email.max"),
          v =>
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) || this.$i18n.t("profile.rules.email.validEmail")
        ],
        description: [
          v => v.length <= 300 || this.$i18n.t("profile.rules.description.max")
        ],
        nationality: null,
        website_url: [
          v =>
            /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm.test(
              v
            ) || this.$i18n.t("signUp.rules.websiteUrl.valid")
        ],
        website_name: [
          v => !!v || this.$i18n.t("profile.rules.website_name.required"),
          v => v.length <= 100 || this.$i18n.t("profile.rules.website_name.max")
        ],
        instagram_url: [
          v =>
            /(^(((http(s?):\/\/)|(http(s?):\/\/www.))|www.)instagram.com\/([\w]|\.)+(\/?)$)|^$/.test(
              v
            ) || this.$i18n.t("profile.rules.instagram_url")
        ],
        facebook_url: [
          v =>
            /(^(((http(s?):\/\/)|(http(s?):\/\/www.))|www.)facebook.com\/[\w]+)|^$/.test(
              v
            ) || this.$i18n.t("profile.rules.facebook_url")
        ],
        twitter_url: [
          v =>
            /(^(((http(s?):\/\/)|(http(s?):\/\/www.))|www.)twitter.com\/[\w]+)|^$/.test(
              v
            ) || this.$i18n.t("profile.rules.twitter_url")
        ],
        pinterest_url: [
          v =>
            /(^(((http(s?):\/\/)|(http(s?):\/\/www.))|www.)pinterest.(com|fr|de)\/[\w]+(\/?)$)|^$/.test(
              v
            ) || this.$i18n.t("profile.rules.pinterest_url")
        ]
      },
      valid: true,
      modalBirthdate: false,
      editedCreator: new Creator(),
      displayHowToEditUsernameOrEmail: false
    };
  },
  watch: {
    creator: function() {
      this.populateForm();
    }
  },
  computed: {
    creator() {
      return this.$store.getters.creator;
    }
  },
  methods: {
    populateForm() {
      this.editedCreator = new Creator(
        JSON.parse(JSON.stringify(this.creator))
      );
    },
    editProfile() {
      this.creator.instagramUrl = FormFunctions.urlBuilder(
        this.creator.instagramUrl
      );
      this.creator.pinterestUrl = FormFunctions.urlBuilder(
        this.creator.pinterestUrl
      );
      this.creator.twitterUrl = FormFunctions.urlBuilder(
        this.creator.twitterUrl
      );
      this.creator.facebookUrl = FormFunctions.urlBuilder(
        this.creator.facebookUrl
      );
      this.$store
        .dispatch("editCreatorInformations", this.editedCreator)
        .then(() => {
          this.$emit("closeEditProfileInformation");
          this.$emit("triggerNewSearch");
          this.$store.commit("mutateAlert", "profileUpdated");
        })
        .catch(alert => {
          if (alert.type == "input") {
            this.triggerInputAlert(alert);
          } else {
            this.alert("please refresh");
          }
        });
    }
  },
  created() {
    this.populateForm();
  }
};
</script>

<style scoped>
.saveProfileInformationButton {
  bottom: 0;
  background-color: white;
}
</style>
